module.exports = __webpack_public_path__ + "static/media/beli-pulsa.03674b0e.svg";